import { getLabRequestAttributes } from 'lib/lab/labRequestContext'

const CONTEXT_ATTRIBUTE_KEYS = [
  'utmCampaign',
  'utmContent',
  'utmMedium',
  'utmSource',
  'utmTerm',
  'deviceName',
  'regionCode',
] as const

function presentAttributes(attributes: Record<string, string | undefined>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(attributes).filter((entry): entry is [string, string] => entry[1] != null && entry[1] !== ''),
  )
}

/**
 * Attribute bag Lab v1 sends inside `attributes` for decide, header banners, and modal pop-ups.
 * Cart values are not part of this bag.
 */
export function getLabEvaluateAttributes(state: App.State): Record<string, string> {
  const context = state.system?.features?.context
  const geoStateName = context?.geoStateName?.trim()
  const fromContext: Record<string, string | undefined> = {}
  if (context) {
    for (const key of CONTEXT_ATTRIBUTE_KEYS) {
      const value = context[key]
      fromContext[key] = typeof value === 'string' ? value : undefined
    }
  }
  if (geoStateName) {
    fromContext.geoStateName = geoStateName
  }

  return presentAttributes({
    ...fromContext,
    ...getLabRequestAttributes(state),
  })
}
